import $ from 'jquery';

class Error {

	constructor(title, message, retain) {
		let div = $("<div></div>").addClass("global-error");
		let container = $("<div></div>");
		$(div).html(container);

		$(container).html($("<h3></h3>").html(title));
		$(container).append($("<p></p>").html(message));

		$("body").append(div);
		$("body").addClass("hasError");

		$(div).find("div").hide();
		$(div).hide().fadeIn("fast", () => {
			$(div).find("div").slideDown("fast");
		});

		


		if (retain != true) {
			setTimeout(() => {
				this.close(div);
			}, 2000);
		} else {
			let button = $("<button></button>").addClass("btn btn-default btn-xs").html(window.Lang.get("Ok"));
			$(button).click(e => {
				e.preventDefault();
				this.close(div);
			});
			$(container).append(button);
		}
	}

	close(div) {
		$(div).find("div").slideUp("fast", () => {
			$(div).fadeOut("fast", () => {
				$(div).detach();
				$("body").removeClass("hasError");
			});
		});
	}

}

export default Error;